import React from 'react'
import './Our_Partners.css'
import RedRoundBtn from '../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn'

const Our_Partners = () => {

    const data = [
        "/assets/Image/aboutus/partner/img1.png",
        "/assets/Image/aboutus/partner/img2.png",
        "/assets/Image/aboutus/partner/img3.png",
        "/assets/Image/aboutus/partner/img4.png",
        "/assets/Image/aboutus/partner/img5.png",
        "/assets/Image/aboutus/partner/img6.png",
    ]

    const scrollToSection = (id, offset = 100) => {

        const section = document.getElementById(id);
        if (section) {
            const top = section.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: "smooth" });
        }
    };

    return (
        <section className='Our_Partners'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6 col-md-6'>
                        <div className='our_partner_div'>
                            <p className='section_heading'>Our Partners</p>
                            <p className='subtext'>
                                We work with leading brands in banking and financial services,
                                setting standards across the sector.
                            </p>

                            <div className='row'>
                                {data?.map((item) => {
                                    return (
                                        <div className='col-lg-4 col-md-6 col-sm-4 col-6'>
                                            <div className='img_holder'>
                                                <img src={item} className='comp_logo' />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            <span className="note_holder">* Partner logos are for reference only. Profcyma Financial Solutions is not affiliated with or endorsed by these institutions. Loan approval and terms are determined solely by the respective financial institution.</span>

                        </div>
                    </div>
                    <div className='col-lg-6 col-md-6'>
                        <div className="rigth_side">
                            <div className="img_container">
                                <div className="img_holder">
                                    <img src="\assets\Image\Home\our_partner\bg.png" className="img" />
                                </div>

                                <div className="btn_holder">
                                    <RedRoundBtn btn_name="Get a Loan" onClick={() => scrollToSection("key_feature")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Our_Partners
